export default class Base {
	constructor({ id, code }) {
		this.id = id;
		this.code = code;
	}
}
